import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { GoogleMap, useJsApiLoader, InfoWindow } from "@react-google-maps/api";
import { Card, CardBody, Nav, Row, Col, Modal, Form, Stack } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { useAppDispatch, useAppSelector } from "../../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllMaps } from "../../../redux/handlers/report/getAllMaps.handler";
import { getShop } from "../../../redux/handlers/manage/getShop.handler";
import { getSaleuser } from "../../../redux/handlers/manage/getSaleuser.handler";
import AdvancedMarker from "../../../layouts/AdvancedMarker"; // ✅ import wrapper
import moment from "moment";
import Select from "react-select";
import { Typography } from "@mui/material";
import { getInfoAdminSystem } from "utils/HelperFunction";
import LaoAddressSelect from "layouts/LaoAddressSelect";
export function ReportMaps() {
    var dispatch = useAppDispatch();
    var adminInfo = getInfoAdminSystem(localStorage.getItem("accessToken"));
    var userRoleId = Number((adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userRoleId) || 0);
    var userId = Number((adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userId) || 0);
    var isSaleRole = userRoleId === 3;
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var _useState1 = _sliced_to_array(useState({}), 2), address = _useState1[0], setAddress = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        lat: 17.96234,
        lng: 102.6321
    }), 2), mapCenter = _useState2[0], setMapCenter = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), pinPosition = _useState3[0], setPinPosition = _useState3[1];
    var _useState4 = _sliced_to_array(useState(null), 2), selectedPin = _useState4[0], setSelectedPin = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), optionShop = _useState5[0], setOptionShop = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), shopId = _useState6[0], setShopId = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), shopTypeId = _useState7[0], setShopTypeId = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), opIntendant = _useState8[0], setOpIntendant = _useState8[1];
    var _useState9 = _sliced_to_array(useState(isSaleRole ? userId : ""), 2), saleId = _useState9[0], setSaleId = _useState9[1];
    var _useState10 = _sliced_to_array(useState(null), 2), map = _useState10[0], setMap = _useState10[1];
    var libraries = [
        "marker"
    ];
    var isLoaded = useJsApiLoader({
        googleMapsApiKey: "AIzaSyCoCpKz8UsXgUNaoXm5auWMzCAK6alIRj8",
        libraries: libraries
    }).isLoaded;
    var pinByType = {
        1: "/images/pingreen.png",
        2: "/images/pinorange.png",
        3: "/images/pinred.png"
    };
    var typeShop = {
        1: "RT",
        2: "WT",
        3: "MT"
    };
    var optionShopType = [
        {
            value: "",
            label: "ทั้งหมด"
        },
        {
            value: 1,
            label: "RT"
        },
        {
            value: 2,
            label: "WT"
        },
        {
            value: 3,
            label: "MT"
        }
    ];
    var getAllMapsReducer = useAppSelector(function(state) {
        return state.getAllMapsReducer;
    });
    var getShopReducer = useAppSelector(function(state) {
        return state.getShopReducer;
    });
    var getSaleuserReducer = useAppSelector(function(state) {
        return state.getSaleuserReducer;
    });
    var loadMaps = function() {
        var queryParams = _object_spread({
            shopId: shopId,
            type: shopTypeId,
            searchTxt: filterText,
            saleId: isSaleRole ? userId : saleId
        }, address.sh_branch_laoprovince_id && {
            provinceid: Number(address.sh_branch_laoprovince_id)
        }, address.sh_branch_laodistrict_id && {
            districtid: Number(address.sh_branch_laodistrict_id)
        }, address.sh_branch_laovillage_id && {
            villageid: Number(address.sh_branch_laovillage_id)
        });
        dispatch(getAllMaps({
            queryParams: queryParams,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        loadMaps();
        dispatch(getShop({}, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        if (!isSaleRole) {
            dispatch(getSaleuser({
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, []);
    useEffect(function() {
        setIsLoading(getShopReducer.isFetching || getSaleuserReducer.isFetching);
        if (getShopReducer.data) {
            var shops = getShopReducer.data.data;
            var visibleShops = isSaleRole ? shops.filter(function(shop) {
                return Number(shop.sh_branch_intendant) === userId;
            }) : shops;
            var arr = [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ].concat(_to_consumable_array(new Map(visibleShops.filter(function(v) {
                var _v_shShop;
                return (_v_shShop = v.shShop) === null || _v_shShop === void 0 ? void 0 : _v_shShop.sh_shop_name;
            }).map(function(v) {
                var _v_shShop;
                return [
                    v.sh_branch_shid,
                    {
                        value: v.sh_branch_shid,
                        label: (_v_shShop = v.shShop) === null || _v_shShop === void 0 ? void 0 : _v_shShop.sh_shop_name
                    }
                ];
            })).values()));
            setOptionShop(arr);
        }
        if (isSaleRole) {
            setOpIntendant([
                {
                    value: userId,
                    label: (adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userFullName) || "ผู้ใช้งานปัจจุบัน"
                }
            ]);
        } else if (getSaleuserReducer.data) {
            var arr1 = [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ];
            getSaleuserReducer.data.data.map(function(ele) {
                return arr1.push({
                    value: ele.sys_user_id,
                    label: ele.sys_user_fullname
                });
            });
            setOpIntendant(arr1);
        }
    }, [
        getShopReducer,
        getSaleuserReducer
    ]);
    useEffect(function() {
        setIsLoading(getAllMapsReducer.isFetching);
        if (getAllMapsReducer.data && !getAllMapsReducer.isError) {
            var _getAllMapsReducer_data_data, _getAllMapsReducer_data;
            var data = (_getAllMapsReducer_data = getAllMapsReducer.data) === null || _getAllMapsReducer_data === void 0 ? void 0 : (_getAllMapsReducer_data_data = _getAllMapsReducer_data.data) === null || _getAllMapsReducer_data_data === void 0 ? void 0 : _getAllMapsReducer_data_data.map(function(item) {
                var _item_shShop, _item_shShop1;
                return {
                    lat: Number(item.sh_branch_ggmaplat),
                    lng: Number(item.sh_branch_ggmaplong),
                    name: (_item_shShop = item.shShop) === null || _item_shShop === void 0 ? void 0 : _item_shShop.sh_shop_name,
                    remark: item.sh_branch_name,
                    typeshop: (_item_shShop1 = item.shShop) === null || _item_shShop1 === void 0 ? void 0 : _item_shShop1.sh_shop_typeshop
                };
            });
            setPinPosition(data);
        }
    }, [
        getAllMapsReducer
    ]);
    // const loadSearchPin = () => {
    //   if ( getAllMapsReducer.data ) {
    //     if ( filterText === "" || filterText === null || filterText === undefined ) {
    //       const data = getAllMapsReducer.data?.data?.map(item => ({
    //         lat: Number(item.sh_branch_ggmaplat),
    //         lng: Number(item.sh_branch_ggmaplong),
    //         name: item.shShop?.sh_shop_name,
    //         remark: item.sh_branch_name,
    //         typeshop: item.sh_branch_typeshop,
    //       }));
    //       setPinPosition(data);
    //       setMapCenter({ lat: 17.962340409269306, lng: 102.63210393264156 });
    //     } else {
    //       const data = getAllMapsReducer.data?.data
    //         ?.filter(item =>{
    //           const shopName = item.shShop?.sh_shop_name?.toLowerCase() || "";
    //           const branchName = item.sh_branch_name?.toLowerCase() || "";
    //           const search = filterText.toLowerCase();
    //           return shopName.includes(search) || branchName.includes(search);
    //         })
    //         .map(item => ({
    //           lat: Number(item.sh_branch_ggmaplat),
    //           lng: Number(item.sh_branch_ggmaplong),
    //           name: item.shShop?.sh_shop_name,
    //           remark: item.sh_branch_name,
    //           typeshop: item.sh_branch_typeshop,
    //         }));
    //       setPinPosition(data);
    //       if (data && data.length > 0) {
    //         setMapCenter({ lat: data[0].lat, lng: data[0].lng });
    //       }
    //     }
    //   }
    // };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายงานแผนที่ร้านค้า"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "รายงานแผนที่ร้านค้า"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2 mb-4",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body p-3",
                    children: [
                        /*#__PURE__*/ _jsxs(Row, {
                            children: [
                                /*#__PURE__*/ _jsx(LaoAddressSelect, {
                                    values: address,
                                    onChange: function(changes) {
                                        return setAddress(function(current) {
                                            return _object_spread({}, current, changes);
                                        });
                                    }
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 0,
                                    lg: 3,
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 p-0",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "ค้นหาร้านค้า"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                className: "w-100 select-st-3",
                                                placeholder: "ค้นหาร้านค้า",
                                                options: optionShop,
                                                defaultValue: 0,
                                                value: optionShop.find(function(opt) {
                                                    return opt.value === shopId;
                                                }) || "",
                                                onChange: function(e) {
                                                    setShopId(e ? e.value : "");
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 0,
                                    lg: 3,
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 p-0",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "ค้นหาประเภทร้านค้า"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3 z-2",
                                                placeholder: "ค้นหาประเภทร้านค้า",
                                                options: optionShopType,
                                                value: optionShopType.find(function(opt) {
                                                    return opt.value === shopTypeId;
                                                }) || "",
                                                onChange: function(e) {
                                                    return setShopTypeId(e ? e.value : "");
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 0,
                                    lg: 3,
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 p-0",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "ค้นหาเซลล์ที่ดูแล"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3 z-2",
                                                placeholder: "ค้นหาเซลล์ที่ดูแล",
                                                options: opIntendant,
                                                value: opIntendant.find(function(opt) {
                                                    return opt.value === saleId;
                                                }) || "",
                                                onChange: function(e) {
                                                    return setSaleId(e ? e.value : "");
                                                },
                                                isClearable: !isSaleRole,
                                                isDisabled: isSaleRole
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 12,
                                    lg: 2,
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control mt-[12px]",
                                        placeholder: "ค้นหาชื่อร้านค้า / สาขา",
                                        onChange: function(e) {
                                            setFilterText(e.target.value);
                                        // handleSearchList(statusContract, e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 12,
                                    lg: 1,
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        className: "btn-st-7 w-100 px-2 mt-[12px]",
                                        onClick: function() {
                                            loadMaps();
                                        },
                                        variant: "",
                                        children: "ค้นหา"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 12,
                                    lg: 2,
                                    children: /*#__PURE__*/ _jsx(Card, {
                                        className: "mb-2",
                                        children: /*#__PURE__*/ _jsxs(CardBody, {
                                            children: [
                                                "จำนวนร้านค้าสาขา: ",
                                                pinPosition.length,
                                                " แห่ง"
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            style: {
                                height: "600px",
                                width: "100%"
                            },
                            children: isLoaded && /*#__PURE__*/ _jsx(GoogleMap, {
                                mapContainerStyle: {
                                    width: "100%",
                                    height: "100%"
                                },
                                center: mapCenter,
                                zoom: 12,
                                onLoad: setMap,
                                onUnmount: function() {
                                    return setMap(null);
                                },
                                options: {
                                    mapId: "8c9785216caad627a4461ca8"
                                },
                                children: pinPosition.map(function(pin, idx) {
                                    var _pin_name;
                                    var pinIcon = pinByType[pin.typeshop] || "/images/pinred.png";
                                    return ((_pin_name = pin.name) === null || _pin_name === void 0 ? void 0 : _pin_name.trim()) && pin.name != undefined && /*#__PURE__*/ _jsx(AdvancedMarker, {
                                        map: map,
                                        position: {
                                            lat: pin.lat,
                                            lng: pin.lng
                                        },
                                        title: pin.name,
                                        content: '<img src="'.concat(pinIcon, '" style="width:35px;height:35px;" />'),
                                        onClick: function(marker) {
                                            if (!window.infoWindow) {
                                                window.infoWindow = new window.google.maps.InfoWindow();
                                            }
                                            window.infoWindow.setContent('\n                          <div style="min-width:160px">\n                            <strong>'.concat(pin.name, "</strong> (").concat(typeShop[pin.typeshop], ")<br/>\n                            ").concat(pin.remark || "", "\n                          </div>\n                        "));
                                            window.infoWindow.open(map, marker);
                                        }
                                    }, idx);
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
